import { z } from 'zod';

export const guestProfileNameSchema = z.object({
  displayName: z.string().optional(),
  givenName: z.string().optional(),
  familyName: z.string().optional(),
});

export const guestProfileEmailSchema = z.object({
  value: z.string(),
  primary: z.boolean().optional(),
});

export const guestProfilePhoneNumberSchema = z.object({
  value: z.string(),
  type: z.string().optional(),
});

export const guestProfileSystemAttributeSchema = z.object({
  name: z.string().optional(),
  value: z.union([z.string(), z.boolean()]).optional(),
});

export const guestProfileCustomerTypeSchema = z.enum(['customers', 'anonymousCustomers', 'anonymous']);

/**
 * Profile object stored in guest reducer state (`state.guest.profile`).
 * Parsed from the Profile API `userProfile` field returned by `getGuestProfile()`.
 */
export const guestProfileSchema = z.object({
  uid: z.string().optional(),
  name: guestProfileNameSchema.optional(),
  emails: z.array(guestProfileEmailSchema).optional(),
  phoneNumbers: z.array(guestProfilePhoneNumberSchema).optional(),
  customerType: z.union([guestProfileCustomerTypeSchema, z.string()]).optional(),
  systemAttributes: z.array(guestProfileSystemAttributeSchema).optional(),
  addresses: z.array(z.looseObject({})).optional(),
  socialConnections: z.array(z.looseObject({})).optional(),
  extendedAttributes: z.array(z.looseObject({})).optional(),
});

/** Profile API response wrapper for `GET /users/2.0/me`. */
export const guestProfileApiResponseSchema = z.object({
  statusMessage: z.string().optional(),
  statusCode: z.string().optional(),
  userProfile: guestProfileSchema,
});

/** Flattened guest contact details derived from a GuestProfile via selectors. */
export const guestDetailsSchema = z.object({
  first: z.string(),
  last: z.string(),
  email: z.string(),
  phone: z.string(),
});
